export default "__VITE_ASSET__BkySDrjP__"